import Vue from 'vue'
import Vuex from 'vuex'

import outgoing from './outgoing'
import user from './user'
import file_trace from './file_trace'
import cryptbox from './cryptbox'
import file from './file'
import mobile_protect from './mobile_protect'
import compliance_audit from './compliance_audit'

// i18n接入
import resources from '../assets/locales/resources';
import { i18nPlugin } from '@sailor/i18n-vue';
Vue.use(i18nPlugin, (i18nClient) => {
  i18nClient.init({
    fallbackLng: 'zh-CN',
    ns: 'translation', // 与 i18n.config.json 中 namespaces.name 保持一致；
    resources,
  });
});

Vue.use(Vuex);
const debug: boolean = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    user,
    outgoing,
    file_trace,
    cryptbox,
    file,
    mobile_protect,
    compliance_audit,
  },
  strict: debug
});

export default store
